export const getBatchActionsLoading = state => state.batchActions.loading;
export const getBatchActionsError = state => state.batchActions.error;
export const getBatchActionsType = state => state.batchActions.actionType; 


// WEBPACK FOOTER //
// ./src/selectors/batchActionsSelectors.js